/* CandyZaExpress add-ons: age gate, chat assistant, shipping timeline. No dependencies. */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Shared: business-day math (processing + USPS transit)
  ------------------------------------------------------------------ */
  var SHIP = window.CZX_SHIPPING || null; // injected by shipping-config snippet

  function ymd(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function isHoliday(d) {
    return SHIP && SHIP.holidays && SHIP.holidays.indexOf(ymd(d)) !== -1;
  }
  function isBusinessDay(d) {
    var day = d.getDay();
    return day !== 0 && day !== 6 && !isHoliday(d);
  }
  function addBusinessDays(start, n) {
    var d = new Date(start.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (isBusinessDay(d)) n--;
    }
    return d;
  }
  // "Now" expressed in the store's time zone as a plain local Date.
  function storeNow() {
    var tz = (SHIP && SHIP.timezone) || 'America/Los_Angeles';
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      return new Date(+o.year, +o.month - 1, +o.day, (+o.hour) % 24, +o.minute);
    } catch (e) { return new Date(); }
  }
  // Day 0 = the business day the order is "received" (respects cut-off + weekends).
  function orderDay() {
    var d = storeNow();
    var cutoff = (SHIP && SHIP.cutoffHour) || 16;
    if (!isBusinessDay(d) || d.getHours() >= cutoff) {
      d.setHours(0, 0, 0, 0);
      d = addBusinessDays(d, 1);
    }
    d.setHours(0, 0, 0, 0);
    return d;
  }
  function fmt(d, withWeekday) {
    return d.toLocaleDateString('en-US', withWeekday ? { weekday: 'short', month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric' });
  }
  function estimate(transitMin, transitMax) {
    var base = orderDay();
    var pMin = SHIP.procMin, pMax = SHIP.procMax;
    var shipMin = addBusinessDays(base, pMin);
    var shipMax = addBusinessDays(base, pMax);
    var arriveMin = addBusinessDays(shipMin, transitMin);
    var arriveMax = addBusinessDays(shipMax, transitMax);
    return { base: base, shipMin: shipMin, shipMax: shipMax, arriveMin: arriveMin, arriveMax: arriveMax };
  }
  window.CZX = { estimate: estimate, orderDay: orderDay, fmt: fmt, addBusinessDays: addBusinessDays };

  /* ------------------------------------------------------------------
     1. Age gate
  ------------------------------------------------------------------ */
  function initAgeGate() {
    var gate = document.getElementById('czx-age');
    if (!gate) return;
    if (!document.documentElement.classList.contains('czx-age-locked')) { gate.remove(); return; }
    gate.hidden = false;
    var days = parseInt(gate.getAttribute('data-remember-days'), 10) || 30;
    var exitUrl = gate.getAttribute('data-exit-url') || 'https://www.google.com';
    var yes = gate.querySelector('[data-age-yes]');
    var no = gate.querySelector('[data-age-no]');
    var denied = gate.querySelector('[data-age-denied]');

    yes.addEventListener('click', function () {
    try { sessionStorage.setItem('czx_age_ok', 'yes'); } catch (e) {}
    
      gate.style.transition = 'opacity .35s';
      gate.style.opacity = '0';
      setTimeout(function () { gate.remove(); }, 380);
    });
    no.addEventListener('click', function () {
      denied.hidden = false;
      yes.disabled = true;
      setTimeout(function () { window.location.href = exitUrl; }, 1800);
    });
    setTimeout(function () { yes.focus(); }, 50);
  }

  /* ------------------------------------------------------------------
     2. Chat assistant
  ------------------------------------------------------------------ */
  function initChat() {
    var root = document.querySelector('[data-czx-chat]');
    var cfgEl = document.getElementById('czx-chat-config');
    if (!root || !cfgEl) return;
    var C;
    try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var panel = root.querySelector('[data-chat-panel]');
    var log = root.querySelector('[data-chat-log]');
    var chips = root.querySelector('[data-chat-chips]');
    var form = root.querySelector('[data-chat-form]');
    var input = form.querySelector('input');
    var teaser = root.querySelector('[data-chat-teaser]');
    var toggles = root.querySelectorAll('[data-chat-toggle]');
    var launcher = root.querySelector('.czx-chat__launcher');
    var opened = false, greeted = false;
    var subscribed = false;
    try { subscribed = !!localStorage.getItem('czx_subscribed'); } catch (e) {}
    if (subscribed) root.classList.add('badge-hidden');

    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function scroll() { log.scrollTop = log.scrollHeight; }
    function add(html, who) {
      var el = document.createElement('div');
      el.className = 'czx-msg czx-msg--' + (who || 'bot');
      el.innerHTML = html;
      log.appendChild(el);
      scroll();
      return el;
    }
    function raw(el) { log.appendChild(el); scroll(); }
    function bot(html, delay) {
      var typing = add('•••', 'bot');
      typing.classList.add('czx-msg--typing');
      return new Promise(function (res) {
        setTimeout(function () { typing.classList.remove('czx-msg--typing'); typing.innerHTML = html; scroll(); res(typing); }, delay || 450);
      });
    }
    function setChips(list) {
      chips.innerHTML = '';
      list.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'czx-chip'; b.textContent = c;
        b.addEventListener('click', function () { handle(c, true); });
        chips.appendChild(b);
      });
    }
    var DEFAULT_CHIPS = ['Shipping times', 'Where is my order?', 'Returns & refunds', 'What is THCA?', 'Legal in my state?', 'Shop products'];
    if (!subscribed) DEFAULT_CHIPS.unshift('Get ' + C.percent + '% off');

    function range(a, b) { return a === b ? (a + '') : (a + '–' + b); }
    function eta(min, max) {
      if (!SHIP) return '';
      var e = estimate(min, max);
      return '<br><small>Order now → ships ' + fmt(e.shipMin) + '–' + fmt(e.shipMax) + ' → arrives about <strong>' + fmt(e.arriveMin) + '–' + fmt(e.arriveMax) + '</strong>.</small>';
    }

    var A = {
      shipping: function () {
        return '<strong>Two things add up to your delivery date:</strong><ul>' +
          '<li><strong>Processing</strong> — ' + range(C.procMin, C.procMax) + ' business days on a normal day, ' + range(C.busyMin, C.busyMax) + ' during high-volume periods. Orders after ' + C.cutoff + ' or on weekends/holidays start the next business day.</li>' +
          '<li><strong>' + esc(C.groundName) + '</strong> — ' + range(C.groundMin, C.groundMax) + ' business days in transit <em>after</em> it ships.' + eta(C.groundMin, C.groundMax) + '</li>' +
          '<li><strong>' + esc(C.priorityName) + '</strong> — ' + range(C.priorityMin, C.priorityMax) + ' business days in transit <em>after</em> it ships.' + eta(C.priorityMin, C.priorityMax) + '</li></ul>' +
          'Transit times are USPS estimates and don\'t include processing. <a href="/pages/shipping-policy">Full shipping policy →</a>';
      },
      tracking: function () {
        return 'Once your order ships you\'ll get an email with a USPS tracking number — that usually lands within ' + range(C.procMin, C.procMax) + ' business days of ordering (' + range(C.busyMin, C.busyMax) + ' when we\'re busy).<br><br>' +
          'If it\'s been longer than that with no tracking, email <a href="mailto:' + esc(C.email) + '">' + esc(C.email) + '</a> with your order number. Note that USPS tracking can take 24 hours to update after we hand off the package.';
      },
      returns: function () {
        return '<strong>Because of the nature of our products, we can\'t accept returns of any kind.</strong><br><br>' +
          'Refunds or replacements are reviewed case by case. To open a claim, email <a href="mailto:' + esc(C.email) + '">' + esc(C.email) + '</a> within <strong>' + C.claimDays + ' days</strong> of the delivery date with your order number and clear <strong>photos and/or video</strong> supporting your claim.<br><br>' +
          'Shipping charges are non-refundable (they pay for the label). <a href="/pages/returns-refunds">Refund policy →</a>';
      },
      address: function () {
        return 'Please double-check your shipping address before you check out. If USPS can\'t deliver because the address is incomplete or incorrect, we\'re not able to take responsibility for the package.<br><br>If you just placed an order and spotted a mistake, email <a href="mailto:' + esc(C.email) + '">' + esc(C.email) + '</a> right away — we can usually fix it before the label prints.';
      },
      insurance: function () {
        return 'We strongly recommend adding <strong>shipping insurance</strong> at checkout. Once a package is handed to USPS, how it\'s handled is out of our control. Insurance covers packages delivered to the wrong address, marked delivered but not received, or stolen — as long as you provide supporting proof within ' + C.claimDays + ' days of the delivery scan.';
      },
      hours: function () {
        return 'We work <strong>' + esc(C.hours) + '</strong>. We don\'t ship on weekends or holidays. Orders placed after our ' + C.cutoff + ' cut-off (for example Friday night) are processed the next business day — usually Monday, unless it\'s a holiday.';
      },
      thca: function () {
        return '<strong>THCA</strong> (tetrahydrocannabinolic acid) is the naturally occurring, non-intoxicating acid form of THC found in raw hemp flower. When heated it converts to THC, so it can be intoxicating when smoked or vaporized.<br><br>Our products are hemp-derived and lab-tested to contain no more than 0.3% Delta-9 THC by dry weight. You can view lab results on our <a href="/pages/coas-lab-results">COAs page</a>. Must be 21+ to purchase. <a href="/pages/thca-compliance">Compliance details →</a>';
      },
      legal: function () {
        return 'Hemp-derived THCA is federally regulated under the 2018 Farm Bill, but <strong>state laws vary and change often</strong>. We currently do not ship to: <strong>' + esc(C.restricted) + '</strong>. Several other states restrict certain product types.<br><br>It\'s your responsibility to know your local laws before ordering. <a href="/pages/thca-compliance">See our compliance page →</a>';
      },
      age: function () {
        return 'You must be <strong>21 or older</strong> to purchase from CandyZaExpress. We may ask for ID verification on orders.';
      },
      coa: function () {
        return 'Every batch is third-party lab tested. Certificates of Analysis are on our <a href="/pages/coas-lab-results">COAs & Lab Results page</a>.';
      },
      payment: function () {
        return 'We accept the payment methods shown at checkout. If a payment fails, try another card or contact <a href="mailto:' + esc(C.email) + '">' + esc(C.email) + '</a>.';
      },
      thanks: function () { return 'You\'re welcome. Anything else I can help with?'; },
      hello: function () { return 'Hi there. Ask me about shipping, our products, or policies — or tap a button below.'; },
      human: function () {
        return 'You can reach our team at <a href="mailto:' + esc(C.email) + '">' + esc(C.email) + '</a>. We reply during business hours (' + esc(C.hours) + ').';
      }
    };

    function productsCard() {
      var wrap = document.createElement('div');
      wrap.className = 'czx-msg czx-msg--bot czx-products';
      if (!C.products || !C.products.length) {
        wrap.innerHTML = 'Browse everything in the <a href="' + esc(C.shopUrl) + '">shop →</a>';
        return wrap;
      }
      C.products.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'czx-product'; a.href = p.url;
        a.innerHTML = (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '<div class="czx-product__ph"></div>') +
          '<div><div class="czx-product__title">' + esc(p.title) + '</div><div class="czx-product__price">' + esc(p.price) + '</div></div>' +
          '<span class="czx-product__cta">VIEW →</span>';
        wrap.appendChild(a);
      });
      var more = document.createElement('a');
      more.href = C.shopUrl; more.className = 'czx-product__cta'; more.style.textAlign = 'right'; more.textContent = 'SHOP ALL →';
      wrap.appendChild(more);
      return wrap;
    }

    function subscribeCard() {
      var wrap = document.createElement('div');
      wrap.className = 'czx-msg czx-msg--bot czx-sub';
      if (subscribed) {
        wrap.innerHTML = '<div class="czx-sub__title">You\'re already on the list</div><p>Use this code at checkout:</p>' + codeBox();
        bindCopy(wrap);
        return wrap;
      }
      wrap.innerHTML = '<div class="czx-sub__title">Get ' + C.percent + '% off your first order</div>' +
        '<p>Join our email list for new drops and store updates and I\'ll unlock your code instantly. 21+ only.</p>' +
        '<form><input type="email" name="email" placeholder="you@email.com" required aria-label="Email address"><button class="btn" type="submit">UNLOCK</button></form><div class="czx-sub__err" hidden></div>';
      var f = wrap.querySelector('form');
      var err = wrap.querySelector('.czx-sub__err');
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = f.email.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = 'Please enter a valid email.'; err.hidden = false; return; }
        var btn = f.querySelector('button'); btn.disabled = true; btn.textContent = '…';
        var fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('contact[email]', email);
        fd.append('contact[tags]', 'newsletter,chat-welcome');
        fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
          .catch(function () {})
          .then(function () {
            subscribed = true;
            try { localStorage.setItem('czx_subscribed', email); } catch (e2) {}
            root.classList.add('badge-hidden');
            wrap.innerHTML = '<div class="czx-sub__title">You\'re in.</div><p>Here\'s your ' + C.percent + '% code — enter it at checkout:</p>' + codeBox() + '<p style="margin-top:10px">Applied to your first order. Happy shopping.</p>';
            bindCopy(wrap);
            setChips(['Shop products', 'Shipping times', 'What is THCA?']);
          });
      });
      return wrap;
    }
    function codeBox() {
      return '<div class="czx-code"><code>' + esc(C.code) + '</code><button type="button" data-copy>COPY</button></div>';
    }
    function bindCopy(scope) {
      var b = scope.querySelector('[data-copy]');
      if (!b) return;
      b.addEventListener('click', function () {
        try { navigator.clipboard.writeText(C.code); b.textContent = 'COPIED'; setTimeout(function () { b.textContent = 'COPY'; }, 1500); } catch (e) {}
      });
    }

    var RULES = [
      [/(discount|coupon|promo|code|% ?off|15|subscribe|newsletter|email list|sign ?up|deal|sale)/i, 'subscribe'],
      [/(where.*order|order status|track|tracking|hasn'?t (shipped|arrived)|not (shipped|arrived)|when.*(arrive|come|get here)|my order)/i, 'tracking'],
      [/(how long|ship|deliver|delivery|priority|ground|usps|transit|processing|fast|arrive|eta)/i, 'shipping'],
      [/(return|refund|exchange|replace|damaged|broken|wrong item|missing item|money back|cancel)/i, 'returns'],
      [/(address|wrong house|insufficient|undeliverable|typo)/i, 'address'],
      [/(insurance|insured|stolen|lost|says delivered|never (got|received)|not received|porch)/i, 'insurance'],
      [/(hours|open|weekend|saturday|sunday|holiday|cut.?off|friday)/i, 'hours'],
      [/(legal|state|law|ship to|texas|georgia|idaho|arkansas|allowed|banned)/i, 'legal'],
      [/(thca|thc|what is|potent|high|effect|strength|convert|decarb)/i, 'thca'],
      [/(age|21|18|id |identification|verify|old)/i, 'age'],
      [/(coa|lab|test|certificate|analysis|purity)/i, 'coa'],
      [/(pay|payment|card|declined|checkout)/i, 'payment'],
      [/(shop|product|flower|pre.?roll|vape|strain|recommend|best|popular|buy|what do you (sell|have))/i, 'products'],
      [/(human|person|agent|someone|support|contact|email you|talk to)/i, 'human'],
      [/(thank|thx|ty)/i, 'thanks'],
      [/^(hi|hello|hey|yo|sup)\b/i, 'hello']
    ];
    function classify(q) {
      for (var i = 0; i < RULES.length; i++) if (RULES[i][0].test(q)) return RULES[i][1];
      return null;
    }

    function handle(text, fromChip) {
      var q = text.trim();
      if (!q) return;
      add(esc(q), 'user');
      var intent = classify(q);
      if (fromChip) {
        if (/^Get /.test(q)) intent = 'subscribe';
        else if (q === 'Shop products') intent = 'products';
        else if (q === 'Shipping times') intent = 'shipping';
        else if (q === 'Where is my order?') intent = 'tracking';
        else if (q === 'Returns & refunds') intent = 'returns';
        else if (q === 'What is THCA?') intent = 'thca';
        else if (q === 'Legal in my state?') intent = 'legal';
      }
      var after = DEFAULT_CHIPS.filter(function (c) { return c !== q; });
      if (intent === 'subscribe') {
        bot('Great choice.').then(function () { raw(subscribeCard()); setChips(after); });
      } else if (intent === 'products') {
        bot('Here\'s what\'s popular right now:').then(function () {
          raw(productsCard());
          if (!subscribed) bot('Want ' + C.percent + '% off your first order? Tap "Get ' + C.percent + '% off".', 700);
          setChips(after);
        });
      } else if (intent && A[intent]) {
        bot(A[intent]()).then(function () {
          if (intent === 'shipping' || intent === 'tracking') bot('Tip: at checkout, the shipping option you pick shows its USPS transit time — remember that starts <em>after</em> processing.', 800);
          setChips(after);
        });
      } else {
        bot('I\'m not sure I caught that. I can help with shipping times, order status, returns, THCA questions, or products — or email <a href="mailto:' + esc(C.email) + '">' + esc(C.email) + '</a> and a human will get back to you.').then(function () { setChips(DEFAULT_CHIPS); });
      }
    }

    function open() {
      opened = true;
      root.classList.add('is-open');
      panel.hidden = false;
      teaser.hidden = true;
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      try { sessionStorage.setItem('czx_chat_teaser', '1'); } catch (e) {}
      if (!greeted) {
        greeted = true;
        bot(esc(C.greeting), 300).then(function () {
          raw(productsCard());
          if (!subscribed) return bot('First time here? Subscribe and I\'ll unlock <strong>' + C.percent + '% off</strong> your first order.', 900);
        }).then(function () { setChips(DEFAULT_CHIPS); });
      }
      setTimeout(function () { input.focus(); }, 100);
    }
    function close() {
      root.classList.remove('is-open');
      panel.hidden = true;
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }
    toggles.forEach(function (t) { t.addEventListener('click', function () { panel.hidden ? open() : close(); }); });
    teaser.addEventListener('click', function (e) { if (!e.target.closest('[data-chat-teaser-close]')) open(); });
    teaser.querySelector('[data-chat-teaser-close]').addEventListener('click', function () {
      teaser.hidden = true;
      try { sessionStorage.setItem('czx_chat_teaser', '1'); } catch (e) {}
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); var v = input.value; input.value = ''; handle(v, false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });

    // Teaser pop-up (once per browser session, after the age gate is cleared)
    var teaserSeen = false;
    try { teaserSeen = !!sessionStorage.getItem('czx_chat_teaser'); } catch (e) {}
    if (!teaserSeen) {
      var tick = setInterval(function () {
        if (document.documentElement.classList.contains('czx-age-locked')) return;
        clearInterval(tick);
        setTimeout(function () { if (!opened) teaser.hidden = false; }, C.delay || 0);
      }, 300);
    }
  }

  /* ------------------------------------------------------------------
     3. Shipping timeline widget (cart page) + acknowledgement
  ------------------------------------------------------------------ */
  function initShippingWidget() {
    var w = document.querySelector('[data-czx-ship]');
    if (!w || !SHIP) return;
    var opts = w.querySelectorAll('.czx-ship__opt');
    var cutoffEl = w.querySelector('[data-cutoff-msg]');
    var base = orderDay();
    var now = storeNow();
    var sameDay = ymd(base) === ymd(now);

    if (cutoffEl) {
      if (sameDay) {
        var h = SHIP.cutoffHour, mins = (h - now.getHours()) * 60 - now.getMinutes();
        cutoffEl.innerHTML = 'Order within <strong>' + Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm</strong> to start processing today.';
      } else {
        cutoffEl.innerHTML = 'Orders placed now start processing on <strong>' + fmt(base, true) + '</strong> (next business day).';
      }
    }
    opts.forEach(function (opt) {
      var min = +opt.getAttribute('data-min'), max = +opt.getAttribute('data-max');
      var e = estimate(min, max);
      var etaEl = opt.querySelector('.czx-ship__eta');
      if (etaEl) etaEl.innerHTML = 'Ships ' + fmt(e.shipMin) + '–' + fmt(e.shipMax) + '<br>Estimated arrival <strong>' + fmt(e.arriveMin, true) + ' – ' + fmt(e.arriveMax, true) + '</strong>';
      opt.addEventListener('click', function () {
        opts.forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        var r = opt.querySelector('input'); if (r) r.checked = true;
        var pref = document.querySelector('[data-ship-pref]'); if (pref) pref.value = opt.getAttribute('data-name') + ' (' + min + '–' + max + ' business days transit after processing)';
      });
    });
    var steps = w.querySelector('[data-steps]');
    if (steps) {
      var pMin = SHIP.procMin, pMax = SHIP.procMax;
      steps.innerHTML =
        '<div class="czx-step"><strong>1. Order received</strong><span>' + fmt(base, true) + '</span>' + (sameDay ? 'Before today\'s ' + SHIP.cutoffLabel + ' cut-off' : 'Next business day after cut-off / weekend') + '</div>' +
        '<div class="czx-step"><strong>2. Processing</strong><span>' + (pMin === pMax ? pMin : pMin + '–' + pMax) + ' business days</span>Ships ' + fmt(addBusinessDays(base, pMin)) + '–' + fmt(addBusinessDays(base, pMax)) + '</div>' +
        '<div class="czx-step"><strong>3. USPS transit</strong><span>Depends on the option you choose</span>Tracking emailed when it ships</div>';
    }
    // Acknowledgement checkbox gates the checkout button
    var ack = document.querySelector('[data-czx-ack]');
    var checkoutBtn = document.querySelector('[data-czx-checkout]');
    if (ack && checkoutBtn) {
      checkoutBtn.disabled = !ack.checked;
      ack.addEventListener('change', function () { checkoutBtn.disabled = !ack.checked; });
    }
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () { initAgeGate(); initChat(); initShippingWidget(); });
})();
